import React, { useState, useEffect } from 'react'
import { apiRecovery, apiNewPassword } from 'api-methods'
import {Link} from "react-router-dom";
import '../css/Recovery.css'

const RecoveryPage = () => {
    const [error, setError] = useState('')
    const [success, setSuccess] = useState('')
    const [loading, setLoading] = useState(false)
    const [isResetMode, setIsResetMode] = useState(false)
    const [resetParams, setResetParams] = useState({ login: '', code: '' })

    useEffect(() => {
        // Проверяем параметры URL при загрузке компонента
        const urlParams = new URLSearchParams(window.location.search)
        const userLogin = urlParams.get('USER_LOGIN')
        const resetCode = urlParams.get('RESET_CODE')

        if (userLogin && resetCode) {
            setIsResetMode(true)
            setResetParams({
                login: userLogin,
                code: resetCode
            })
        }
    }, [])

    const handlePasswordReset = async (e) => {
        e.preventDefault()
        const formData = new FormData(e.target)
        const password = formData.get('password')
        const confirmPassword = formData.get('confirmPassword')

        if (!password || !confirmPassword) {
            setError('Введите пароль и подтверждение пароля')
            return
        }

        if (password !== confirmPassword) {
            setError('Пароли не совпадают')
            return
        }

        setLoading(true)
        setError('')
        setSuccess('')

        await apiNewPassword({
            "login": resetParams.login,
            "resetCode": resetParams.code,
            "newPassword": password
        })
            .then(data => {
                if (data.code === 200) {
                    setSuccess(data.message || 'Пароль успешно изменен')
                } else {
                    setError(data.message || 'Ошибка при изменении пароля')
                }
            })
            .catch(_ => {
                setError('Произошла ошибка при изменении пароля')
            })
            .finally(() => {
                setLoading(false)
            })
    }

    const handlePasswordRecovery = async (e) => {
        e.preventDefault()
        const formData = new FormData(e.target)
        const login = formData.get('login')

        if (!login) {
            setError('Введите логин')
            return
        }

        setLoading(true)
        setError('')
        setSuccess('')

        await apiRecovery({ "login": login })
            .then(data => {
                if (data.code === 200) {
                    setSuccess(data.message || 'Инструкции по восстановлению пароля отправлены на вашу почту')
                } else {
                    setError(data.message || 'Пользователь не найден')
                }
            })
            .catch(_ => {
                setError('Произошла ошибка при отправке запроса')
            })
            .finally(() => {
                setLoading(false)
            })
    }

    if (isResetMode) {
        return (
            <div className="RecoveryPage">
                <div className="RecoveryPage__left-panel">
                    <div className="RecoveryPage__left-content">
                        <div className="RecoveryPage__left-logo"></div>
                        <h1 className="RecoveryPage__left-title">Восстановление пароля</h1>
                        <p className="RecoveryPage__left-subtitle">
                            Введите новый пароль для вашего аккаунта
                        </p>
                    </div>
                </div>

                <div className="RecoveryPage__form-container">
                    <form className="RecoveryPage__form" onSubmit={handlePasswordReset}>
                        <div className="RecoveryPage__form-header">
                            <div className="RecoveryPage__mobile-logo"></div>
                            <h2 className="RecoveryPage__title">Смена пароля</h2>
                            <p className="RecoveryPage__subtitle">
                                Пользователь: <strong>{resetParams.login}</strong>
                            </p>
                        </div>

                        <div className="RecoveryPage__form-group">
                            <label className="RecoveryPage__label" htmlFor="password">Новый пароль</label>
                            <input
                                className="RecoveryPage__input"
                                type="password"
                                id="password"
                                name="password"
                                autoComplete="new-password"
                                disabled={loading}
                                placeholder="Введите новый пароль"
                            />
                        </div>

                        <div className="RecoveryPage__form-group">
                            <label className="RecoveryPage__label" htmlFor="confirmPassword">Повторите пароль</label>
                            <input
                                className="RecoveryPage__input"
                                type="password"
                                id="confirmPassword"
                                name="confirmPassword"
                                autoComplete="new-password"
                                disabled={loading}
                                placeholder="Повторите новый пароль"
                            />
                        </div>

                        {error && (<div className="RecoveryPage__error RecoveryPage__error--visible">{error}</div>)}
                        {success && (<div className="RecoveryPage__success RecoveryPage__success--visible">{success}</div>)}

                        <button
                            type="submit"
                            className={`allPagesStyleButton underlined ${loading ? 'RecoveryPage__button--loading' : ''}`}
                            disabled={loading}
                        >
                            {loading ? 'Смена пароля...' : 'Изменить пароль'}
                        </button>

                        <div className="RecoveryPage__back">
                            <Link to="/login" className="RecoveryPage__back-button">
                                ← Вернуться
                            </Link>
                        </div>
                    </form>
                </div>
            </div>
        )
    }

    // Оригинальная форма восстановления пароля
    return (
        <div className="RecoveryPage">
            <div className="RecoveryPage__left-panel">
                <div className="RecoveryPage__left-content">
                    <div className="RecoveryPage__left-logo"></div>
                    <h1 className="RecoveryPage__left-title">Восстановление пароля</h1>
                    <p className="RecoveryPage__left-subtitle">
                        Введите ваш логин, чтобы получить инструкции по восстановлению пароля
                    </p>
                </div>
            </div>

            <div className="RecoveryPage__form-container">
                <form className="RecoveryPage__form" onSubmit={handlePasswordRecovery}>
                    <div className="RecoveryPage__form-header">
                        <div className="RecoveryPage__mobile-logo"></div>
                        <h2 className="RecoveryPage__title">Восстановление пароля</h2>
                        <p className="RecoveryPage__subtitle">Введите логин вашего аккаунта</p>
                    </div>

                    <div className="RecoveryPage__form-group">
                        <label className="RecoveryPage__label" htmlFor="login">Логин</label>
                        <input
                            className="RecoveryPage__input"
                            type="text"
                            id="login"
                            name="login"
                            autoComplete="username"
                            disabled={loading}
                            placeholder="Введите ваш логин"
                        />
                    </div>

                    {error && (<div className="RecoveryPage__error RecoveryPage__error--visible">{error}</div>)}
                    {success && (<div className="RecoveryPage__success RecoveryPage__success--visible">{success}</div>)}

                    <button
                        type="submit"
                        className={`allPagesStyleButton underlined ${loading ? 'RecoveryPage__button--loading' : ''}`}
                        disabled={loading}
                    >
                        {loading ? 'Отправка...' : 'Восстановить пароль'}
                    </button>

                    <div className="RecoveryPage__back">
                        <Link to="/login" className="RecoveryPage__back-button">
                            ← Вернуться
                        </Link>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default RecoveryPage
